


























































import { computed, defineComponent, ref } from "@vue/composition-api";
import Vue from "vue";
import { useStaticPages } from "@/hooks/useStaticPages";
import config from "@/config";
import PageTitle from "@/components/PageTitle";
import SiteLogo from "@/components/SiteLogo";
import SocialLogin from "@/components/SocialLogin";

export default defineComponent({
  name: "LoginContainer",
  components: { SiteLogo, PageTitle, SocialLogin },
  props: {
    signup: { type: Boolean, default: true },
    title: { type: String, required: true },
  },
  setup(props) {
    const { pages, getPages } = useStaticPages();

    // override for https://scrile.atlassian.net/browse/CO-12944
    const titleAppend = ref<Vue | undefined>();

    const visibleLinks = computed(() =>
      pages.value?.filter(
        page =>
          page.visible &&
          (!props.signup || !["/static/privacy-policy.html", "/static/terms-of-use.html"].includes(page.path))
      )
    );

    const showPoweredBy = computed(() => !config.featureHideScrileLink);

    const termsOfUse = computed(() => {
      return pages.value.find(p => p.path.includes("terms-of-use"));
    });
    const privacyPolicy = computed(() => {
      return pages.value.find(p => p.path.includes("privacy-policy"));
    });

    getPages();

    return {
      termsOfUse,
      privacyPolicy,
      visibleLinks,
      showPoweredBy,
      titleAppend,
    };
  },
});
